import { handleActions } from 'redux-actions';

import * as commonReducers from './common';
import * as actions from '../actions/comments';

const {
  create,
  update,
  remove,
} = commonReducers.operationTypes;

const updateCommentSuccessReducer = (state, { payload }) => ({
  ...state,
  [update]: false,
  items: {
    ...state.items,
    [payload._id]: {
      ...state.items[payload._id],
      text: payload.text,
    },
  },
});

export const commentsReducer = handleActions(
  {
    // create
    [actions.createCommentRequest]: commonReducers.commonRequestReducer(create),
    [actions.createCommentFailure]: commonReducers.commonFailureReducer(create),
    [actions.createCommentSuccess]: commonReducers.createSuccessReducer,

    // update
    [actions.updateCommentRequest]: commonReducers.commonRequestReducer(update),
    [actions.updateCommentFailure]: commonReducers.commonFailureReducer(update),
    [actions.updateCommentSuccess]: updateCommentSuccessReducer,

    // delete
    [actions.deleteCommentRequest]: commonReducers.commonRequestReducer(remove),
    [actions.deleteCommentFailure]: commonReducers.commonFailureReducer(remove),
    [actions.deleteCommentSuccess]: commonReducers.deleteSuccessReducer,

    // fetch
    [actions.fetchCommentsSuccess]: commonReducers.fetchSuccessReducer,
  },
  {
    ...commonReducers.defaultState,
  },
);



// WEBPACK FOOTER //
// ./src/redux/reducers/comments.js